import { get, post } from '../utils/request';

// 定义接口返回的数据类型
interface LoginParams {
  email: string;
  code: string;
}

interface GoogleLoginParams {
  token_data: string;
}

interface GetCodeByEmailParams {
  email: string;
}

interface UserInfo {
  id: number;
  username: string;
  email: string;
  avatar?: string;
  roles: string[];
}

interface LoginResult {
  token: string;
  userInfo: UserInfo;
}

// 用户邮箱验证码登录
export const emailLogin = (data: LoginParams) => {
  return post<LoginResult>('/user/save_login_check_email_verification_code', data);
};

// 谷歌登录
export const googleLogin = (data: GoogleLoginParams) => {
  return post<LoginResult>('/user/save_user_by_google', data);
};

// 获取邮箱验证码
export const getCodeByEmail = (data: GetCodeByEmailParams) => {
  return post<LoginResult>('/user/get_email_verification_code', data);
};


// 获取用户会员信息
export const getUserProfile = () => {
  return get('/user/get_user_profile');
};
// 查看token是否有效
export const getTokenValidity = () => {
  return post('/user/check_token_validity');
};
// 获取用户信息
export const getUserInfo = () => {
  return get<UserInfo>('/user/info');
};

// 用户登出
export const logout = () => {
  return post('/user/logout');
};

// 修改用户信息
export const updateUserInfo = (data: Partial<UserInfo>) => {
  return post('/user/update', data);
}; 

// 删除用户信息
export const deleteUserAccount = () => {
  return post('/user/save_delete_user_account')
};

// 保存用户信息
export const saveUserInfo = (data: any) => {
  return post('/user/save_user', data)
}; 
// 获取商户信息
export const getMerchantById = (data: { merchant_id: string }) => {
  return get('/merchant/get_merchant_by_id', data)
};

// 更新商户信息
export const updateMerchantInfo = (data: any) => {
  return post('/merchant/save_merchant', data)
};


// 获取验证码 手机号 {phone: string}
export const getCodeByPhone = (data: {phone: string}) => {
  return post<LoginResult>('/user/get_phone_verification_code', data)
}


// 手机号登录 
export const phoneLogin = (data: {phone: string,code: string}) => {
  return post('/user/save_login_check_phone_verification_code', data)
}


// user/get_user_account_suggestions

export const getUserAccountSuggestions = (data: {query: string}) => {
  return get('/user/get_user_account_suggestions', data);
}
// 关注店铺列表
export const getUserFollowList = (params: { follow_type: 1 | 2, page: number, page_size: number }) => {
  const { follow_type, page, page_size} = params
  const url = `/user/get_user_follow_list?&page=${page}&page_size=${page_size}${follow_type ? `&follow_type=${follow_type}` : ''}` 
  return get(url);
}
